export default __webpack_public_path__ + "static/media/logoFigma.80d73e77.png";